import { CACHE_STALE_MS, CACHE_TTL_MS } from './constants';

export const getCachedEntry = (storageKey, cacheKey) => {
    try {
        const raw = localStorage.getItem(storageKey);
        if (!raw) {
            return null;
        }
        const map = JSON.parse(raw);
        const entry = map[cacheKey];
        if (!entry || !entry.timestamp) {
            return null;
        }
        const age = Date.now() - entry.timestamp;
        if (age > CACHE_TTL_MS) {
            return null;
        }

        return { data: entry.data, isStale: age > CACHE_STALE_MS };
    } catch {
        return null;
    }
};
